import { ShortlistState } from "PFTypes";

export const STATES_ALLOWING_FILL: Readonly<ShortlistState[]> = [
  "pending",
  "accepted",
  "assigned",
  "rejected"
];

export const LOCKED_SHORTLIST_STATES: Readonly<ShortlistState[]> = ["booked", "confirmed"];
